import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=0784d640&scoped=true"
import script from "./Lead.vue?vue&type=script&lang=js"
export * from "./Lead.vue?vue&type=script&lang=js"
import style0 from "./Lead.vue?vue&type=style&index=0&id=0784d640&prod&lang=scss&scoped=true"
import style1 from "./Lead.vue?vue&type=style&index=1&id=0784d640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0784d640",
  null
  
)

export default component.exports